"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = require("../../App");
var LayoutContext_1 = require("../../Common/LayoutContext");
var i18n_1 = require("../../i18n/i18n");
// tslint:disable-next-line:max-line-length
var PhoneEmailVerificationStrings_1 = __importDefault(require("../PhoneEmailVerification/PhoneEmailVerificationStrings"));
var ImpressionTracker_1 = __importDefault(require("../Tracking/ImpressionTracker"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var MfaBlocked = function (_a) {
    var _b = _a.additionalMfaOptions, additionalMfaOptions = _b === void 0 ? null : _b;
    var _c = React.useContext(App_1.RiskContext), experience = _c.experience, state = _c.state;
    var _d = React.useContext(LayoutContext_1.LayoutContext), clearActionState = _d.clearActionState, setPrimaryAction = _d.setPrimaryAction, setSecondaryAction = _d.setSecondaryAction;
    React.useEffect(function () {
        // Blocked state uses the footer to handle the modal action.
        setPrimaryAction(clearActionState);
        if (setSecondaryAction) {
            setSecondaryAction(clearActionState);
        }
    }, []);
    var experienceStrings = i18n_1.getStringsForExperience(TwoFactorAuthenticationStrings_1["default"], experience);
    var blockedMsg = state.challenge === App_1.RiskActions.PhoneEmailVerify
        ? PhoneEmailVerificationStrings_1["default"].tooManyInvalidAttemptsExplanation()
        : experienceStrings;
    return (React.createElement(ImpressionTracker_1["default"], { onImpression: function () { return VerifyAccountTracking_1.trackOnBlockedPageTrigger(state.workflow); } },
        React.createElement(design_language_1.StackChildren, null,
            React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, blockedMsg),
            React.createElement(design_language_1.InlineChildren, { justifyContent: design_language_1.InlineChildren.Justification.Center },
                React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.Large }, additionalMfaOptions)))));
};
exports["default"] = MfaBlocked;
